module.exports = __webpack_public_path__ + "media/images/payments/skrill-dark-dbd0080126f71f19893d360da18f8abd.svg";